import { useStore } from '../../../module/rootStore'
import { substituteValue } from '../../../lib/substitute/substituteValue'
import styles from './StepInputInfo.module.scss'
import { observer } from 'mobx-react-lite'
import { IInputStatus } from '../../../interface/progress.interface'
import BankSslBanner from '../../BankSsl/BankSslBanner'
import { useEffect, useState } from 'react'
import { IInputType } from '../../../interface/steps.interface'

interface Props {
  name: string
  currentStep: number
  inputRef: (
    el: HTMLDivElement
  ) => HTMLDivElement | React.RefObject<HTMLDivElement>
  children?: JSX.Element | JSX.Element[]
}

function StepInputInfo({ name, currentStep, inputRef, children }: Props) {
  const { values, inputsData, replacements, inputLayout } = useStore().StepsStore
  const title = inputsData[name]?.title
  const subtitle = inputsData[name]?.subtitle
  const label = inputsData[name]?.label
  const type = inputsData[name]?.type

  const { isOptions } = useStore().ProgressStore
  const { status } =
    useStore().ProgressStore.stepsProgress[currentStep].inputs[name]

  console.log(name, status)
  if (status === IInputStatus.disabled || status === IInputStatus.dispensable)
    return <></>

  const modTitle =
    typeof title?.text === 'string'
      ? substituteValue(title.text, values, replacements)
      : title?.text
  const modSubtitle =
    typeof subtitle === 'string'
      ? substituteValue(subtitle, values, replacements)
      : subtitle
  const modLabel =
    typeof label === 'string'
      ? substituteValue(label, values, replacements)
      : label

  const isOp = isOptions.indexOf(name) !== -1

  const wrapperStyle =
    `${styles.wrapper} `
    + `${type === IInputType.select ? styles.flex_center : ''}`
    + `${!inputLayout[currentStep] ? styles.wrapper_margin : ''} `
    + `${(modTitle || modSubtitle) ? styles.wrapper_gap : ''}`

  return (
    <>

      <div className={wrapperStyle} key={name} ref={inputRef}>
        <div>
          {/* {
            isOp &&
            <span className={styles.optional}>Pregunta opcional</span>
          } */}
          {(modTitle || modSubtitle) && (
            <div className={styles.titleWrapper}>

              {modTitle && (
                <div
                  className={
                    title.variant === 'large' ? styles.titleLarge : styles.title
                  }
                >
                  {modTitle || modLabel}
                </div>
              )}
              {modSubtitle && <div className={styles.subtitle}>{modSubtitle}</div>}
            </div>
          )}
        </div>

        {children}
      </div>
    </>
  )
}

export default observer(StepInputInfo)
